import React from "react";
import { CircleDollarSign, Github, Layers, ShieldCheck } from "lucide-react";
import { countPhrase, creditMetric, githubMetric, guardrailCopy } from "./workspaceOverviewModel";

export default function WorkspaceStatusPanel({
  overview,
  readOnly = false,
  canConnect = false,
  onReview,
  onAddCodebase,
}) {
  const copy = guardrailCopy(overview);
  const setup = overview?.setup || {};
  const credits = overview?.credits;
  const empty = (setup.repositoryCount || 0) === 0;
  const primaryIsAdd = empty || copy.title === "Reconnect GitHub" || copy.title === "Connect GitHub";

  return (
    <section className={`rr-guardrail is-${copy.tone}`} aria-labelledby="guardrail-title">
      <div className="rr-guardrail-main">
        <span className="rr-guardrail-icon" aria-hidden="true"><ShieldCheck size={18} /></span>
        <div>
          <h2 id="guardrail-title">
            {copy.title}
            {copy.badge ? <span className={`rr-live is-${copy.tone}`}><span className="rr-live-dot" aria-hidden="true" />{copy.badge}</span> : null}
          </h2>
          <p>{copy.body}</p>
          {copy.support ? <p className="rr-guardrail-support">{copy.support}</p> : null}
        </div>
      </div>
      {readOnly ? <p className="rr-guardrail-note">Your role can view this workspace. A member starts reviews and connects codebases.</p> : (
        <div className="rr-guardrail-actions">
          {primaryIsAdd ? (
            canConnect ? <button type="button" className="rr-button" onClick={onAddCodebase}>Add codebase</button> : null
          ) : (
            <>
              <button type="button" className="rr-button" onClick={onReview}>Review a pull request</button>
              {canConnect ? <button type="button" className="rr-button secondary" onClick={onAddCodebase}>Add codebase</button> : null}
            </>
          )}
        </div>
      )}
      {!empty ? (
        <ul className="rr-guardrail-metrics">
          <li><Layers size={15} aria-hidden="true" />{countPhrase(setup.repositoryCount, "codebase")}</li>
          <li><Github size={15} aria-hidden="true" />{githubMetric(setup)}</li>
          <li>
            <CircleDollarSign size={15} aria-hidden="true" />
            {creditMetric(credits)}
            {credits?.billingEnabled && credits.reserved > 0 ? <span className="rr-sr">{`${credits.reserved} reviews reserved`}</span> : null}
          </li>
        </ul>
      ) : null}
    </section>
  );
}
